// https://webpack.js.org/guides/public-path/#on-the-fly
window.__webpack_public_path__ = `${window.Disy.contextPath}/bundles/`;
